export default {
  title: 'AI 客服',
  collapse: '收起',
  inputPlaceholder: '请输入问题，回车发送',
  inputTip: '请输入消息，按Enter键或点击发送按钮发送',
  send: '发送',
  serviceShort: '客',
  querying: '正在为您查询{label}...',
  productInfo: '商品信息',
  orderInfo: '订单信息',
  orderDetails: '订单详情',
  unitPrice: '价格',
  quantity: '数量',
  freight: '运费',
  specification: '规格',
  colour: '颜色',
  goodsSize: '尺寸',
  orderTime: '创建日期',
  remark: '备注',
  monthlySales: '月销',
  error: '错误',
  connectionError: '连接异常',
  networkError: '网络请求失败',
  unknown: '未知',
  searchByImage: '以图搜商品',
  newChat: '新建对话',
  chatHistory: '历史会话',
  deleteChat: '删除',
  deleteChatConfirm: '确定删除该会话吗？',
  noHistory: '暂无历史会话',
  backToChat: '返回',
  loadingHistory: '加载中...',
  stopGenerate: '停止生成',
  generationStopped: '已停止输出',
  welcome: '您好！我是 selfgm 的 AI 客服小艾，请问有什么可以帮您？',
  logisticsInfo: '物流信息',
  logisticsState: '物流状态',
  logisticsOrderNo: '订单编号',
  logisticsBatchNo: '批次号',
  logisticsRecipient: '收件人',
  logisticsAddress: '收货地址',
  orderId: 'NO',
  orderStatus: '订单状态',
  badCount: '不良处理中数量',
  waitBoxCount: '待装箱数',
  exchangCount: '换货中数量',
  refundCount: '退货数',
  reissueCount: '补发中数量',
  destroyCount: '销毁数',
  netWeight: '净重',
  receiveTime: '到货日期',
  sendTime: '发送日期',
  goodsNumber: '货品数',
  goodsSku: '商品SKU',
  domesticTrackingNo: '中国运单号',
  trackingNo: '运单号',
  clientManagerUserName: '负责人',
  checkLabel: '验标',
  customerRemark: '用户备注',
  recipientName: '收件人',
  phone: '电话',
  zipCode: '邮编',
  address: '地址',
  productPrice: '商品费',
  agentServiceFee: '代购手续费',
  chineseFreight: '国内运费',
  chinaFreight: '中国运费',
  inspectionFee: '检品费',
  labelFee: '标签费',
  problemHandlingFee: '异常处理费',
  returnFee: '退货运费',
  categoryFee: '仓库保管费',
  exchangeRate: '汇率',
  exchangeInspectionFee: '换回细检品费',
  total: '合计',
  yuan: '元',
  containerInfo: '批次信息',
  containerOrderInfo: '装箱单信息',
  badOrderInfo: '不良订单信息',
  categoryFlag: '仓库保管',
  goodsNameCus: '品名',
  chineseFreightFee: '中国运费',
  locatorNo: '库位',
  putIntent: '包装意向',
  inspection: '检品',
  containerBatchNo: '装箱编号',
  containerState: '状态',
  createTime: '创建日期',
  sendTime: '发送日期',
  boxesCount: '箱数',
  weight: '重量',
  logisticeCompany: '国际物流',
  recipientName: '收件人',
  importCode: '进口商编码',
  importInfo: '进口商信息',
  senderName: '进口商',
  senderZipCode: '进口商邮编',
  senderAddress: '进口商地址',
  receiverInfo: '收件人信息',
  receiveInfo: '收件信息',
  zipCode: '收件人邮编',
  deliveryAddress: '收件人地址',
  settlement: '结算',
  goodsNumber: '货品数',
  totalAmount: '总应付款',
  route: '线路',
  airTransport: '空运',
  seaTransport: '海运',
  userId: '用户ID',
  waybillNumber: '运单号',
  sendArea: '发送地区',
  senderInfo: '发件人信息',
  comments: '备注',
  goodsCount: '商品数量',
  containerGoodsCount: '申请数量',
  containerGoodsCountInstalled: '装箱数量',
  boxNum: '箱号',
  canApplyCount: '可申请数',
  colour: '颜色',
  capitalRecordInfo: '资金明细',
  tradeNo: '交易编号',
  relationOrderNo: '关联订单号',
  tradeIntro: '交易说明',
  tradeTime: '交易时间',
  tradeType: '交易类型',
  amount: '金额',
  balance: '余额',
  recharge: '充值',
  payOrder: '订单付款',
  compensate: '赔偿',
  deduct: '扣款',
  withdrawal: '退金（提现）',
  typeDetail1: '充值',
  typeDetail2: '装箱单付款',
  typeDetail2plus: '国际运费退回',
  typeDetail3: '订单付款',
  typeDetail4: '赔偿',
  typeDetail5: '扣款',
  typeDetail6: '退金（提现）',
  typeDetail7: '购买完扣费',
  typeDetail8: '退货退费',
  typeDetail9: '异常扣费',
  typeDetail10: '账单付款',
  typeDetail11: '仓库保管费',
  typeDetail12: '检品完扣费',
  typeDetail13: '取消购买退费',
  typeDetail14: '取消检品退费',
  typeDetail15: '换回详细检品费',
  typeDetail16: '仓储费',
  typeDetail16plus: '退回仓储费',
}